/**
 * /frontend/src/features/analytics/components/charts/TrendLineChart.js
 */

import React from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Generic line chart for trends.
 * @param {{data:any[],xKey:string,lines:Array<{key:string,label:string,color:string}>,height?:number,yFormatter?:(v:any)=>string}} props
 * @returns {JSX.Element}
 */
const TrendLineChart = ({ data, xKey, lines, height, yFormatter }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <LineChart data={safeData} margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis dataKey={xKey} stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} tickFormatter={yFormatter} />
        <Tooltip formatter={yFormatter} />
        {(lines || []).map((line) => (
          <Line
            key={line.key}
            type="monotone"
            dataKey={line.key}
            name={line.label}
            stroke={line.color || CHART_COLORS.accent}
            strokeWidth={2}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TrendLineChart;
